<template>
  <va-edit-layout :title="title">
    <pqrs-form :id="id" :item="item"></pqrs-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
